import { Navigate, Outlet } from "react-router-dom"

export default function PrivateLoginRoutes({ authenticated }) {
  return authenticated ? <Outlet /> : <Navigate to="/login" />
}
